// extracted by mini-css-extract-plugin
export default {"defaultCard":"Bo-z","otherCards":"Co-z","empty":"Do-z","addNewItem":"Eo-z","disabled":"Fo-z","cardGrid":"Go-z"};